module.exports = __webpack_public_path__ + "static/media/WorkSans_Italic.12167132.woff2";